import { AlertCircle, LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { getNotifications } from "@/api/getNotifications.ts";
import { Notification } from "@/types/notification.ts";
import NotificationCard from "@/components/NotificationCard.tsx";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert.tsx";
import { cn } from "@/lib/utils.ts";
import { useTranslation } from "@/i18n";

const Notifications = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [notifications, setNotifications] = useState<Notification[]>();

  useEffect(() => {
    (async () => {
      try {
        const response = await getNotifications();
        setNotifications(response.data.results);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e: unknown) {
        setError(t("notifications.fetchFailed"));
      }
    })();
  }, [t]);

  return (
    <div
      className={cn(
        "flex h-full w-full flex-col items-center gap-4",
        className,
      )}
    >
      {loading && <LoaderCircle className="size-6 animate-spin" />}
      {!loading && !notifications?.length && (
        <div>{t("notifications.empty")}</div>
      )}
      {error && (
        <Alert variant="destructive" className="mx-auto my-4 w-fit">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>{t("common.somethingWentWrong")}</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      {!!notifications?.length &&
        notifications.map((notification) => (
          <NotificationCard notification={notification} key={notification.id} />
        ))}
      {!!notifications?.length &&
        notifications.map((notification) => (
          <NotificationCard notification={notification} key={notification.id} />
        ))}
    </div>
  );
};

export default Notifications;
